import { FC } from 'react'
import { Button } from 'components/extend/Button'
import { LinkButton } from 'components/extend/Link'

import s from './OrderFilterSelect.module.less'

export interface OrderFilterResetButtonProps {
  isLaptop: boolean
  isLoading: boolean | undefined
  onReset: () => void
}

export const OrderFilterResetButton: FC<OrderFilterResetButtonProps> = ({ isLaptop, isLoading, onReset }) => {
  if (isLaptop) {
    return (
      <Button block wide appearance="secondary" loading={isLoading} onClick={onReset} size="nm">
        Сбросить фильтр
      </Button>
    )
  }

  return (
    <LinkButton className={s.filterReset} onClick={onReset}>
      Сбросить фильтр
    </LinkButton>
  )
}
